
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"16","viewBox":"0 0 8 6","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.817.174A.569.569 0 007.413 0a.554.554 0 00-.405.174l-4.24 4.379L.986 2.709a.58.58 0 00-.414-.168.567.567 0 00-.409.183.602.602 0 00-.163.427.616.616 0 00.178.421l2.185 2.254A.568.568 0 002.768 6a.554.554 0 00.404-.174l4.645-4.79A.587.587 0 008 .607a.603.603 0 00-.183-.432z","fill":"#1B4332"}})])
          )
        }
      }
    